import React from 'react';
import { Spin, Alert } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useData } from '../../contexts/DataContext';
import { useMap } from '../../contexts/MapContext';
import { MapLayout, CompareLayout } from '../../components/Layout';
import './styles.css';

const MapPage = () => {
  const { loading, error } = useData();
  const { isCompareMode } = useMap();

  // Loading state
  if (loading) {
    return (
      <div className="map-page-loading">
        <Spin
          indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
          tip="Loading map data..."
        />
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="map-page-error">
        <Alert
          message="Error Loading Data"
          description={error}
          type="error"
          showIcon
        />
      </div>
    );
  }

  // Render appropriate layout based on compare mode
  return (
    <div className="map-page">
      {isCompareMode ? <CompareLayout /> : <MapLayout />}
    </div>
  );
};

export default MapPage;
